import PageWrapper from "@/components/layout/page-wrapper";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { RotateCcwSquare, SquareMenuIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useNavigate } from "react-router";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const invoices = [
    {
        id: "https://cool-store.com",
        customer: "Robert Baratheon",
        status: "Active",
        statusColor: "bg-green-200 text-green-800",
        date: "5/30/14",
        dueDate: "7/11/19",
        amount: "$928.41",
    },
    {
        id: "https://awesome-store.com",
        customer: "Arlene McCoy",
        status: "Active",
        statusColor: "bg-green-200 text-green-800",
        date: "6/21/19",
        dueDate: "9/23/16",
        amount: "$396.84",
    },
    {
        id: "https://great-store.com",
        customer: "Devon Lane",
        status: "Inactive",
        statusColor: "bg-red-200 text-red-800",
        date: "7/11/19",
        dueDate: "3/4/16",
        amount: "$490.51",
    },
    {
        id: "https://fantastic-store.com",
        customer: "Ronald Richards",
        status: "Active",
        statusColor: "bg-emerald-200 text-emerald-800",
        date: "4/21/12",
        dueDate: "5/27/15",
        amount: "$601.13",
    },
];

const AccessTableDropdown = () => {
    const navigate = useNavigate();
    return (
        <DropdownMenu>
            <DropdownMenuTrigger>
                <Button size={"sm"} variant="ghost" className="p-2 cursor-pointer">
                    <SquareMenuIcon />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
                <DropdownMenuLabel>Actions</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => navigate("store/312421")}>
                    <RotateCcwSquare /> Change Status
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

const StoreAccessManage = () => {
    return (
        <PageWrapper pageTitle="Store Acess" currentPage="Store Acess">
            <Card className="w-full mx-auto p-4">
                {/* <div className="flex justify-end items-center mb-4">
                    <Button className="bg-blue-600 hover:bg-blue-700 text-white">+ New Invoice</Button>
                </div> */}

                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>
                                <Checkbox />
                            </TableHead>
                            <TableHead>Store URL</TableHead>
                            <TableHead>Customer Name</TableHead>
                            <TableHead>Status</TableHead>
                            <TableHead>Actions</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {invoices.map((invoice) => (
                            <TableRow key={invoice.id} className="hover:bg-muted/20">
                                <TableCell>
                                    <Checkbox />
                                </TableCell>
                                <TableCell className="text-blue-600 font-medium">{invoice.id}</TableCell>
                                <TableCell>{invoice.customer}</TableCell>
                                <TableCell>
                                    <Badge className={invoice.statusColor}>{invoice.status}</Badge>
                                </TableCell>
                                <TableCell>
                                    <div className="flex items-center gap-2">
                                        <AccessTableDropdown />
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Card>
        </PageWrapper>
    );
};

export default StoreAccessManage;
